import React from 'react'
import PropTypes from 'prop-types'
import {Form, Field} from 'simple-react-form'
import TagsField from './TagsField'
import autobind from 'autobind-decorator'

export default class Filter extends React.Component {
  static propTypes = {
    variables: PropTypes.object,
    setVariable: PropTypes.func
  }

  getValues() {
    const variables = this.props.variables || {}
    const value = {
      tags: variables.tags || [],
      filter: variables.filter || ''
    }
    return value
  }

  @autobind
  onChange({filters}) {
    console.log(filters)
    this.props.setVariable('filter', filters.filter)
    this.props.setVariable('tags', filters.tags)
  }

  render() {
    return (
      <div>
        <Form state={this.props.variables} onChange={this.onChange}>
          <Field
            fieldName="filters"
            value={this.getValues()}
            type={TagsField}
            placeholder="Buscar"
          />
        </Form>
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/App/components/fields/TagsFilter/index.js